import * as React from "react";

import { cn } from "@/lib/utils";

export type NativeSelectProps = React.ComponentPropsWithoutRef<"select">;

/**
 * Visual adapter for consumers whose popup intentionally remains owned by the
 * browser/operating system. It deliberately keeps native select appearance and
 * behavior; authored listboxes remain with their existing flow owners.
 */
const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      data-popup-owner="native"
      className={cn(
        "border-input bg-background text-foreground focus-visible:ring-ring h-9 min-w-0 cursor-pointer rounded-md border px-3 py-1.5 text-sm shadow-sm transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
